import { useQuery } from '@tanstack/react-query';
import { meetingApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { getBrowserTimeZone } from 'src/utils';

/** @registry The Meeting Minutes PDF for one meeting, rendered by the server in the browser's time zone. */
export function useMeetingPdf(
  jobId: number | null | undefined,
  meetingId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.meetings.pdf(jobId ?? -1, meetingId ?? ''),
    queryFn: ({ signal }) =>
      meetingApiClient.getMeetingPdf(
        jobId!,
        meetingId!,
        getBrowserTimeZone(),
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && !!meetingId,
    staleTime: 0,
    gcTime: 0,
    // The server renders PDFs one at a time in a single browser, so a failed
    // render is not retried.
    retry: false,
    meta: { errorContext: 'meeting minutes pdf' },
  });
}
